import React, {useContext} from 'react';
import {Link} from "react-router-dom";
import {Disclosure} from '@headlessui/react'
import { MenuIcon, XIcon } from '@heroicons/react/outline'
// import {AppContext} from "../state/ContextProvider";

export type LinkName = 'チーム投手' | 'アカウント情報' | '中等部：ヤング' | '小等部：ジュニア' | '中等部：リトルシニア';
type Props = {
  selectedPage: string;
  setSelectedPage: React.Dispatch<React.SetStateAction<LinkName>>;
}

const navigation: {name:LinkName, href: string}[] = [
  // { name: 'アカウント情報', href: '/account' },
  // { name: 'チーム投手', href: '/mypage' },
  { name: '中等部：ヤング', href: '/' },
  { name: '中等部：リトルシニア', href: '/ls' },
  { name: '小等部：ジュニア', href: '/jr' },
];

function classNames(...classes:any) {
  return classes.filter(Boolean).join(' ')
}

export const TopNav: React.FC<Props> = (props) => {

  // const {authService} = useContext(AppContext);

  return (
    <Disclosure as="nav" className="bg-gray-800">
      {({ open }) => (
        <>
          <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
            <div className="relative flex items-center justify-between h-16">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* モバイル用メニュー*/}
                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                <div className="hidden sm:block sm:ml-6">
                  {/* ルートの表示*/}
                  <div className="flex space-x-4">
                    {navigation.map((item) => (
                      <Link
                        key={item.name}
                        to={item.href}
                        className={classNames(
                          item.name === props.selectedPage ? 'bg-gray-900 text-white text-xl' : 'text-gray-300 hover:bg-gray-700 hover:text-white text-xl',
                          'px-3 py-2 rounded-md text-sm font-medium'
                        )}
                        aria-current={item.name === props.selectedPage ? 'page' : undefined}
                        onClick={ ()=> {props.setSelectedPage(item.name)} }
                      >
                        {item.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
              <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
              {/*  ログアウトボタン設置エリア*/}
              </div>
            </div>
          </div>

          {/* モバイル用メニュー：内部*/}
          <Disclosure.Panel className="sm:hidden">
            {/* ルートの表示*/}
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}>
                  <Disclosure.Button
                    className={classNames(
                      item.name === props.selectedPage ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                      'px-3 py-2 rounded-md text-sm font-medium'
                    )}
                    aria-current={item.name === props.selectedPage ? 'page' : undefined}
                    onClick={ ()=> {props.setSelectedPage(item.name)} }
                  >
                    {item.name}
                  </Disclosure.Button>
                </Link>
              ))}
            </div>
          </Disclosure.Panel>

        </>
      )}
    </Disclosure>
  )
}
